import { styled } from '@mui/material/styles';
import { Section } from 'components/styledComponents';

export const Name = styled('h1')(({ theme }) => ({
  wordBreak: 'break-all',
  color: theme.color.primary.main,
  fontWeight: theme.fontWeight.light,
  margin: 0
}));

export const ProfileImage = styled('img')(() => ({
  objectPosition: 'top'
}));

export const UserDetails = styled('div')(({ theme }) => ({
  alignItems: 'flex-start',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  paddingRight: theme.spacing(3),
  '& .submitAppButton': {
    width: '100%'
  },
  '& .SubmitAppButtonLabel': {
    whiteSpace: 'pre-wrap'
  }
}));

export const UserInfo = styled(Section)(() => ({}));

export const DetailsWrapper = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(8)} 0`
}));

export const DetailsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  margin: theme.spacing(-2),
  [`& ${ProfileImage}, & ${UserDetails}`]: {
    margin: theme.spacing(2)
  },
  [`& ${ProfileImage}`]: {
    '@media (max-width: 500px)': {
      margin: `${theme.spacing(2)} auto`
    }
  },
  [`& ${UserDetails}`]: {
    flexGrow: 999
  }
}));
